<app-nav></app-nav>

<div class="page-content">
  <h4>Gallery</h4>
  <app-photoshow [data]="photos"></app-photoshow>
</div>
